import { render, staticRenderFns } from "./pastRecords.vue?vue&type=template&id=3f6a68a2&scoped=true&"
import script from "./pastRecords.vue?vue&type=script&lang=js&"
export * from "./pastRecords.vue?vue&type=script&lang=js&"
import style0 from "./pastRecords.vue?vue&type=style&index=0&id=3f6a68a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a68a2",
  null
  
)

export default component.exports